import React from 'react';
import { Github, ExternalLink } from 'lucide-react';

function Footer({ config }) {
  return (
    <footer className="mt-auto py-8 bg-white dark:bg-slate-800 border-t border-slate-200 dark:border-slate-700 text-center text-sm text-slate-600 dark:text-slate-400">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center justify-center gap-4 mb-2 flex-wrap">
          {config.githubUrl && (
            <>
              <a
                href={config.githubUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-blue-500 transition-colors"
              >
                <Github className="w-4 h-4" /> Repository
              </a>
              {config.profile.link && <span>•</span>}
            </>
          )}
          {config.profile.link && (
            <a
              href={config.profile.link}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 hover:text-blue-500 transition-colors"
            >
              <ExternalLink className="w-4 h-4" /> {config.profile.text}
            </a>
          )}
        </div>
        <p>
          {config.author.name && (
            <>
              Designed & Built by{' '}
              {config.author.website && config.author.website !== '#' ? (
                <a
                  href={config.author.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 hover:text-blue-600 font-medium"
                >
                  {config.author.name}
                </a>
              ) : (
                <span className="font-medium">{config.author.name}</span>
              )}
            </>
          )}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
